//import i18next from 'i18next';
import { en } from '../assets/locales/en'
import { it } from '../assets/locales/it'

var tr = {
    userlng: function () {
        var userLang = navigator.language || navigator.userLanguage;
        if (!!userLang) {
            var abv = userLang.slice(0, 2);
            //  console.log("userLang: ", userLang, " the brief word is : ", abv.toUpperCase());
            return abv.toUpperCase();
        }
    },
    t: function (key) {

        switch (this.userlng()) {
            case "IT":
                return it[key]
            // case "FR":

            //  fr[key]
            default://default is italian
                // console.log(en.key);
                return en[key]
        }
    }
}
export default tr;





// WEBPACK FOOTER //
// ./src/libs/tr.js